import { render, staticRenderFns } from "./VErrors.vue?vue&type=template&id=d1d6e55a&lang=pug"
import script from "./VErrors.vue?vue&type=script&lang=ts"
export * from "./VErrors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports